import { agroApi } from "../../../../redux/api/api";
import { IFertilizerOctoberResponse, IFertilizerOctoberParams } from "./types";
import { Paths } from "../../../../paths";

export const fertilizerOctoberApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getFertilizerOctober: builder.query<IFertilizerOctoberResponse, IFertilizerOctoberParams>({
      query: ({ year, territorialUnitRegionId }) => ({
        url: `${Paths.chemicalization.winterCerealFertilizer}/analytical-data`,
        method: "GET",
        params: {
          ...(year && { year }),
          territorialUnitRegionId
        }
      }),
    }),
    getFertilizerOctoberAll: builder.query<IFertilizerOctoberResponse, { year?: string }>({
      query: ({ year }) => ({
        url: `${Paths.chemicalization.winterCerealFertilizer}/analytical-data`,
        method: "GET",
        params: {
          ...(year && { year }),
          territorialUnitRegionId: "0"
        }
      }),
    }),
  }),
  overrideExisting: false,
});

export const { 
  useGetFertilizerOctoberQuery,
  useGetFertilizerOctoberAllQuery 
} = fertilizerOctoberApi;